import { createReducer } from "redux-create-reducer";

import { EXPORT_LOGS_CSV, CLEAR_EXPORT_LOGS_CSV } from "../types";

const initialState = {
  data: {},
  isLoading: false,
};

const exportLogsCsvReducer = createReducer(initialState, {
  [EXPORT_LOGS_CSV.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_LOGS_CSV.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_LOGS_CSV.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [EXPORT_LOGS_CSV.FULFILLED]: (state, { payload }) => {
    const newState = Object.assign({}, state, {
      data: {
        fileBytes: new Blob([payload.data], { type: "text/csv" }),
        fileName: payload.headers["content-disposition"]
          .split("filename=")[1]
          .split(";")[0]
          .replace(".csv", ""), // type option will take care of the extension
      },
      isLoading: false,
    });
    return newState;
  },
  [CLEAR_EXPORT_LOGS_CSV]: () => {
    return initialState;
  },
});

export default exportLogsCsvReducer;



// WEBPACK FOOTER //
// ./src/features/log/reducers/exportLogsReducer.js